import { FC, useState } from 'react';
import { PaymentMethod, PaymentType } from '../../../helpers/constants';
import SavedCardOptions from './SavedCardOptions';

type Props = {
  newCardHandler: () => void;
  savedCardHandler: (cardId: number) => void;
  walletHandler: () => void;
  type?: PaymentType;
};

const Payment: FC<Props> = ({ newCardHandler, savedCardHandler, walletHandler, type }) => {
  const [step, setStep] = useState(1);
  const [paymentMethod, setPaymentMethod] = useState('');

  const onSelectPaymentMethod = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPaymentMethod(event.target.value);
  };

  const onClickNextHandler = () => {
    setStep(2);
  };

  return (
    <>
      {step === 2 && (
        <div className='text-end mb-3 mt-5'>
          <button className='btn btn-light-primary btn-sm' onClick={() => setStep(1)}>
            <i className='bi bi-chevron-left'></i> Back
          </button>
        </div>
      )}
      {step === 1 && (
        <div className='mb-10 mt-10'>
          <label className='d-flex flex-stack mb-5 cursor-pointer'>
            <span className='d-flex align-items-center me-2'>
              <span className='d-flex flex-column'>
                <span className='fw-bolder text-hover-primary fs-7'>Pay With A New Card</span>
                <span className='fs-8 fw-bold text-gray-400'>Payment will be charged from your card</span>
              </span>
            </span>

            <span className='form-check form-check-custom form-check-solid'>
              <input name='payment_method' className='form-check-input' type='radio' value={PaymentMethod.NEW_CARD} onChange={onSelectPaymentMethod} defaultChecked={paymentMethod === PaymentMethod.NEW_CARD} />
            </span>
          </label>

          <label className='d-flex flex-stack mb-5 cursor-pointer'>
            <span className='d-flex align-items-center me-2'>
              <span className='d-flex flex-column'>
                <span className='fw-bolder text-hover-primary fs-7'>Pay With A Saved Card</span>
                <span className='fs-8 fw-bold text-gray-400'>Payment will be deducted from your card saved with us</span>
              </span>
            </span>

            <span className='form-check form-check-custom form-check-solid'>
              <input name='payment_method' className='form-check-input' type='radio' value={PaymentMethod.SAVED_CARD} onChange={onSelectPaymentMethod} defaultChecked={paymentMethod === PaymentMethod.SAVED_CARD} />
            </span>
          </label>

          <label className='d-flex flex-stack mb-5 cursor-pointer'>
            <span className='d-flex align-items-center me-2'>
              <span className='d-flex flex-column'>
                <span className='fw-bolder text-hover-primary fs-7'>Pay With Wallet</span>
                <span className='fs-8 fw-bold text-gray-400'>Payment will be charged from your wallet</span>
              </span>
            </span>

            <span className='form-check form-check-custom form-check-solid'>
              <input name='payment_method' className='form-check-input' type='radio' value={PaymentMethod.WALLET} onChange={onSelectPaymentMethod} defaultChecked={paymentMethod === PaymentMethod.WALLET} />
            </span>
          </label>
        </div>
      )}

      {step === 2 && <SavedCardOptions savedCardHandler={savedCardHandler} />}

      {step === 1 && paymentMethod === PaymentMethod.NEW_CARD && (
        <button className='btn btn-primary btn-block w-100' onClick={newCardHandler}>
          {type === PaymentType.REPAYMENT ? 'Repay Loan' : 'Disburse Loan'}
        </button>
      )}

      {step === 1 && paymentMethod === PaymentMethod.WALLET && (
        <button className='btn btn-primary w-100' onClick={walletHandler}>
          {type === PaymentType.REPAYMENT ? 'Repay Loan' : 'Disburse Loan'}
        </button>
      )}

      {paymentMethod === PaymentMethod.SAVED_CARD && step !== 2 && (
        <button className='btn btn-primary w-100' onClick={onClickNextHandler}>
          Next
        </button>
      )}
    </>
  );
};

export default Payment;
